import { NavLink } from "react-router-dom";
import { useConversations } from "@/hooks/queries";
import { cn } from "@/lib/utils";

export function RecentList() {
  const { data, isLoading } = useConversations("", 50);
  const items = (data?.items || []).slice(0, 8);
  if (isLoading) {
    return (
      <div className="mt-6 space-y-2 px-3" data-testid="sidebar-recent-loading">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-3 rounded bg-white/[0.05]" style={{ width: `${70 - i * 12}%` }} />
        ))}
      </div>
    );
  }
  if (!items.length) return null;
  return (
    <div className="mt-6" data-testid="sidebar-recent-list">
      <div className="px-3 pb-2 text-[11px] font-medium uppercase tracking-[0.16em] text-zinc-600">Recent</div>
      <div className="space-y-0.5">
        {items.map((c) => (
          <NavLink
            key={c.id}
            to={`/chat/${c.id}`}
            data-testid={`sidebar-recent-item-${c.id}`}
            className={({ isActive }) =>
              cn(
                "block truncate rounded-lg px-3 py-1.5 text-[13px] transition-colors",
                isActive ? "bg-white/[0.07] text-white" : "text-zinc-400 hover:bg-white/[0.04] hover:text-zinc-200",
              )
            }
          >
            {c.title}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
